import React from "react";
import Modal from "../../../ui-components/Modal/Modal";

const CustomModal = ({ show, handleClose, title, children }) => {
  return (
    <Modal show={show} onHide={handleClose} position="center">
      <Modal.Header closeButton>
        {title}
      </Modal.Header>
      <Modal.Body>
        {children}
      </Modal.Body>
      <Modal.Footer>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomModal;
